import React, { useEffect, useState } from "react";

const MouseFollowerBackground = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updateMousePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", updateMousePosition);
    return () => window.removeEventListener("mousemove", updateMousePosition);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-full -z-10 overflow-hidden pointer-events-none">
      <div
        className="absolute w-96 h-96 bg-red-800 opacity-15 blur-3xl rounded-full transition-transform duration-100"
        style={{
          transform: `translate(${position.x - 192}px, ${position.y - 192}px)`,
        }}
      />
    </div>
  );
};

export default MouseFollowerBackground;
